const API_BASE_FORMATOS_URL = "https://api-formatosoft.hayllis.com";
export default API_BASE_FORMATOS_URL;